import { MutationTree } from 'vuex';
import { State } from './state';

import { Signatur, Vertragspartner } from '@/models/VertragspartnerModels';

export enum MutationTypes {
  SetVertragspartner = 'SETVERTRAGSPARTNER',
  AddVertragspartner = 'ADDVERTRAGSPARTNER',
  AddOrUpdateVertragspartner = 'UPDATEVERTRAGSPARTNER',
  DeleteVertragspartner = 'DELETEVERTRAGSPARTNER',

  SetSignatur = 'SETSIGNATUR',
  AddSignatur = 'ADDSIGNATUR',
  AddOrUpdateSignatur = 'UPDATESIGNATUR',
  DeleteSignatur = 'DELETESIGNATUR',
}

export type Mutations = {
  [MutationTypes.SetVertragspartner](state: State, data: Array<Vertragspartner>): void;
  [MutationTypes.AddVertragspartner](state: State, data: Vertragspartner): void;
  [MutationTypes.AddOrUpdateVertragspartner](state: State, data: Vertragspartner): void;
  [MutationTypes.DeleteVertragspartner](state: State, data: number): void;

  [MutationTypes.SetSignatur](state: State, data: Array<Signatur>): void;
  [MutationTypes.AddSignatur](state: State, data: Signatur): void;
  [MutationTypes.AddOrUpdateSignatur](state: State, data: Signatur): void;
  [MutationTypes.DeleteSignatur](state: State, data: number): void;
};

export const mutations: MutationTree<State> & Mutations = {
  //#region Vertragspartner
  [MutationTypes.SetVertragspartner](state: State, data: Array<Vertragspartner>) {
    state.vertragspartner = data;
    localStorage.setItem('vertragspartner', JSON.stringify(state.vertragspartner));
  },

  [MutationTypes.AddVertragspartner](state: State, data: Vertragspartner) {
    state.vertragspartner.push(data);
    localStorage.setItem('vertragspartner', JSON.stringify(state.vertragspartner));
  },

  [MutationTypes.AddOrUpdateVertragspartner](state: State, data: Vertragspartner) {
    var index = state.vertragspartner.findIndex((p) => p.id == data.id);
    if (index != -1) {
      state.vertragspartner.splice(index, 1, data);
    } else {
      state.vertragspartner.push(data);
    }

    localStorage.setItem('vertragspartner', JSON.stringify(state.vertragspartner));
  },

  [MutationTypes.DeleteVertragspartner](state: State, data: number) {
    var index = state.vertragspartner.findIndex((p) => p.id == data);
    if (index != -1) {
      state.vertragspartner.splice(index, 1);
    }

    localStorage.setItem('vertragspartner', JSON.stringify(state.vertragspartner));
  },
  //#endregion

  //#region Signatur
  [MutationTypes.SetSignatur](state: State, data: Array<Signatur>) {
    state.signaturen = data;
    localStorage.setItem('signaturen', JSON.stringify(state.signaturen));
  },

  [MutationTypes.AddSignatur](state: State, data: Signatur) {
    state.signaturen.push(data);
    localStorage.setItem('signaturen', JSON.stringify(state.signaturen));
  },

  [MutationTypes.AddOrUpdateSignatur](state: State, data: Signatur) {
    var index = state.signaturen.findIndex((p) => p.id == data.id);
    if (index != -1) {
      state.signaturen.splice(index, 1, data);
    } else {
      state.signaturen.push(data);
    }

    localStorage.setItem('signaturen', JSON.stringify(state.signaturen));
  },

  [MutationTypes.DeleteSignatur](state: State, data: number) {
    var index = state.signaturen.findIndex((p) => p.id == data);
    if (index != -1) {
      state.signaturen.splice(index, 1);
    }

    localStorage.setItem('signaturen', JSON.stringify(state.signaturen));
  },
  //#endregion
};
